import { bikes } from "./bikes.mock";
import { recoveryEquipment } from "./recoveryEquipment.mock";
import { sensors } from "./sensors.mock";
import { gymEquipment } from "./gymEquipment.mock";
import type { EquipmentRegistry } from "../types/garage";

export const EQUIPMENT_REGISTRY_SCHEMA_VERSION = 2;

export function createSeedEquipmentRegistry(): EquipmentRegistry {
  return {
    schemaVersion: EQUIPMENT_REGISTRY_SCHEMA_VERSION,
    bikes,
    recoveryEquipment,
    sensors,
    gymEquipment
  };
}
